<template>
  <modal title="Change Password" size="xs" ref="modal">
    <form class="q-gutter-md">
      <password-input label="Current Password" v-model="currentPassword" outlined />
      <password-input label="New Password" v-model="newPassword" outlined />
      <password-input label="Confirm New Password" v-model="confirmNewPassword" outlined />
    </form>
    <template v-slot:actions>
      <async-btn
        label="Change Password"
        color="primary"
        :task="task"
        :disable="!canChange"
        @click="changePassword" />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { Modal as ModalElement } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import PasswordInput from '@/components/form/PasswordInput.vue';
import notify from '@/components/notify';
import { changePassword } from './user';

interface Data {
  currentPassword: string,
  newPassword: string,
  confirmNewPassword: string,
  task: Promise<void>|null
}

export default defineComponent({
  mixins: [ModalMixin],
  components: {
    Modal,
    AsyncBtn,
    PasswordInput,
  },
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      task: null,
    };
  },
  computed: {
    canChange(): boolean {
      return (
        this.currentPassword !== '' && this.newPassword !== ''
      );
    },
  },
  methods: {
    changePassword() {
      if (this.newPassword !== this.confirmNewPassword) {
        notify({
          message: 'Your new password and confirmation password do not match.',
          color: 'danger',
        });
        return;
      }
      this.task = changePassword(this.userId, this.currentPassword, this.newPassword);
      this.task.then(() => {
        (this.$refs.modal as ModalElement).hide();
        notify('Your password has been changed.');
      });
    },
  },
});
</script>
